import "core-js/modules/es.array.map";

/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import MessageRecord from 'wfui-digital-core/es/MessageRecord';
export default (function () {
  var messages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return messages.map(function (_ref) {
    var message = _ref.message,
        level = _ref.level,
        messagePlacement = _ref.messagePlacement;
    return new MessageRecord({
      content: message,
      level: level,
      placement: messagePlacement
    });
  });
});